import React, { useState } from 'react';
import { Search, Plus, Folder, Clock, ChevronRight, MoreVertical } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { Header } from '../components/Header';
import { NewProjectModal } from '../components/NewProjectModal';
import { copy } from '../copy';
export function ProjectListPage() {
  const navigate = useNavigate();
  const [searchQuery, setSearchQuery] = useState('');
  const [isModalOpen, setIsModalOpen] = useState(false);
  const projects = copy.caseList.cases;
  const filteredProjects = projects.filter(p => p.name.toLowerCase().includes(searchQuery.toLowerCase()) || p.description.toLowerCase().includes(searchQuery.toLowerCase()));
  const handleCreateProject = (name: string, description: string) => {
    setIsModalOpen(false);
    navigate('/case');
  };
  return <div className="min-h-screen bg-white dark:bg-[#1a1a1a] text-slate-900 dark:text-[#e5e5e5] transition-colors duration-200" data-id="element-439">
      <Header title={copy.caseList.headerTitle} minimal showProjectLink={false} data-id="element-440" />

      <main className="mx-auto max-w-4xl px-6 py-12" data-id="element-441">
        <div className="flex flex-col md:flex-row md:items-center justify-between gap-6 mb-12" data-id="element-442">
          <div className="flex-1" data-id="element-443">
            <h1 className="text-4xl font-bold text-slate-900 dark:text-white mb-2 tracking-tight" data-id="element-444">
              {copy.caseList.title}
            </h1>
            <p className="text-base text-slate-500 dark:text-[#a3a3a3] leading-relaxed" data-id="element-445">
              {copy.caseList.subtitle}
            </p>
          </div>
          <button onClick={() => setIsModalOpen(true)} className="flex items-center justify-center gap-2 px-5 py-3 bg-slate-900 dark:bg-white text-white dark:text-slate-900 rounded-xl font-semibold hover:bg-slate-800 dark:hover:bg-slate-100 active:scale-[0.98] transition-all shadow-sm hover:shadow-md whitespace-nowrap" data-id="element-446">
            <Plus size={18} strokeWidth={2.5} data-id="element-447" />
            {copy.caseList.newCaseButton}
          </button>
        </div>

        <div className="relative mb-8" data-id="element-448">
          <div className="absolute inset-y-0 left-4 flex items-center pointer-events-none text-slate-400 dark:text-[#555]" data-id="element-449">
            <Search size={20} data-id="element-450" />
          </div>
          <input type="text" placeholder={copy.caseList.searchPlaceholder} value={searchQuery} onChange={e => setSearchQuery(e.target.value)} className="w-full pl-12 pr-4 py-4 bg-slate-50 dark:bg-[#222] border border-slate-200 dark:border-[#333] rounded-2xl outline-none focus:ring-2 focus:ring-blue-500/20 dark:focus:ring-blue-400/20 focus:border-blue-500 dark:focus:border-blue-400 transition-all text-slate-900 dark:text-white placeholder:text-slate-400 dark:placeholder:text-[#555]" data-id="element-451" />
        </div>

        <div className="space-y-3" data-id="element-452">
          {filteredProjects.length > 0 ? filteredProjects.map(project => <div key={project.id} onClick={() => navigate('/case')} className="group flex items-center gap-4 p-6 bg-white dark:bg-[#1a1a1a] border border-slate-200 dark:border-[#333] rounded-2xl hover:border-slate-300 dark:hover:border-[#444] hover:shadow-md dark:hover:shadow-2xl hover:bg-slate-50 dark:hover:bg-[#222] transition-all duration-200 cursor-pointer" data-id="element-453">
                <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-xl bg-slate-100 dark:bg-[#2a2a2a] text-slate-500 dark:text-[#a3a3a3] group-hover:bg-blue-50 dark:group-hover:bg-blue-900/20 group-hover:text-blue-600 dark:group-hover:text-blue-400 transition-all duration-200" data-id="element-454">
                  <Folder size={22} data-id="element-455" />
                </div>

                <div className="flex-1 min-w-0" data-id="element-456">
                  <div className="flex items-center justify-between mb-1.5" data-id="element-457">
                    <h3 className="font-semibold text-base text-slate-900 dark:text-white truncate group-hover:text-slate-900 dark:group-hover:text-white" data-id="element-458">
                      {project.name}
                    </h3>
                    <div className="flex items-center gap-1.5 text-xs text-slate-400 dark:text-[#555] font-medium" data-id="element-459">
                      <Clock size={13} data-id="element-460" />
                      {project.lastActive}
                    </div>
                  </div>
                  <p className="text-sm text-slate-500 dark:text-[#a3a3a3] line-clamp-1 leading-relaxed" data-id="element-461">
                    {project.description}
                  </p>
                </div>

                <div className="flex items-center gap-2" data-id="element-462">
                  <button onClick={e => e.stopPropagation()} className="p-2 text-slate-400 dark:text-[#555] hover:text-slate-600 dark:hover:text-[#a3a3a3] hover:bg-slate-100 dark:hover:bg-white/5 rounded-lg transition-all" data-id="element-463">
                    <MoreVertical size={18} data-id="element-464" />
                  </button>
                  <ChevronRight size={20} className="text-slate-300 dark:text-[#444] group-hover:text-slate-500 dark:group-hover:text-[#a3a3a3] group-hover:translate-x-0.5 transition-all duration-200" data-id="element-465" />
                </div>
              </div>) : <div className="text-center py-24 border-2 border-dashed border-slate-200 dark:border-[#262626] rounded-3xl bg-slate-50/50 dark:bg-[#222]/50" data-id="element-466">
              <div className="flex justify-center mb-5 text-slate-300 dark:text-[#333]" data-id="element-467">
                <Folder size={56} strokeWidth={1.5} data-id="element-468" />
              </div>
              <h3 className="text-lg font-semibold text-slate-900 dark:text-white mb-2" data-id="element-469">
                {copy.caseList.emptyTitle}
              </h3>
              <p className="text-sm text-slate-500 dark:text-[#a3a3a3]" data-id="element-470">
                {copy.caseList.emptyBody}
              </p>
            </div>}
        </div>
      </main>

      <NewProjectModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} onSave={handleCreateProject} data-id="element-471" />
    </div>;
}